import { useMutation } from 'src/core/api/hooks/useMutation';

export const useUpdateCustomFieldValuesMutation = (customFieldId: string) => {
  return useMutation<
    {
      values: {
        id?: string;
        value: string;
        isDefault: boolean;
      }[];
    },
    {
      outcome: string;
      addedCustomFieldValues: { id: string; value: string }[];
    },
    {
      outcome: string;
      addedCustomFieldValues: { id: string; value: string }[];
    }
  >({
    request: {
      type: 'rest',
      target: 'companyAPI',
      endpoint: `/custom-fields-package/custom-fields/${customFieldId}/values`,
      method: 'post',
    },
    reshapeData: (data) => data,
    options: {
      throwOnError: true,
      onSuccess({ client }): void {
        client.invalidateQueries(['customFields']);
        client.invalidateQueries(['useCustomFieldValuesQuery', customFieldId]);
      },
    },
  });
};
